import { useTranslation } from 'react-i18next';
import { href, useLocation, useNavigate } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { profileQueries } from '~entities/user';
import { clearAllRevisions } from '~shared/api';
import { ROUTES } from '~shared/routes';

import { postLogin } from './api';

export const useLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, isError } = useMutation({
    mutationFn: postLogin,
    // A revision left by a previous session makes the backend reject the login
    onMutate: ({ groupName }) => clearAllRevisions(groupName),
    onSuccess: (result, { groupName }) => {
      queryClient.setQueryData(
        profileQueries.detail(groupName).queryKey,
        result
      );

      const homePage = result.isAdmin ? ROUTES.pharmacies : ROUTES.calendar;
      const origin =
        location.state?.from?.pathname || href(homePage, { group: groupName });

      navigate(origin);
    },
  });

  return {
    onLogin: mutateAsync,
    isPending,
    error: isError ? t('auth loginError') : null,
  };
};
